module.exports = __webpack_public_path__ + "img/PD1505110254667563008.5448d230.png";